// @flow
import React, { forwardRef } from 'react';
import AutoSizer from 'react-virtualized-auto-sizer';

import type { Size } from '../shared/types';

export type LayoutOptions = {
  getLayoutDataProps: (Object) => Object,
};

export const getLayoutWrapper = (options) =>
  forwardRef((props, ref) => {
    const { Layout, ...externalProps } = props;
    const layoutProps = options.getLayoutDataProps(props);
    return <Layout {...externalProps} {...layoutProps} ref={ref} />;
  });

export default (options: LayoutOptions) => (LayoutComponent) => {
  const Wrapper = getLayoutWrapper(options);

  return (props) => {
    return <AutoSizer>{(size: Size) => <Wrapper {...props} {...size} Layout={LayoutComponent} />}</AutoSizer>;
  };
};
